import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import plusIcon1 from '../../../asset/img/common/addbutton_plus_primary_icon.svg';
import plusIcon2 from '../../../asset/img/common/addbutton_plus_secondary_icon.svg';
import plusIcon3 from '../../../asset/img/common/addbutton_plus_gray_icon.svg';
import Typography from '../../../components/common/Typography';

const getStatusStyle = status => {
  switch (status) {
    case 'disabled':
      return `
        background: var(--GrayScale-200);
        
      `;
    case 'active':
      return `
        background: var(--GrayScale-100);
      `;
    default:
      return `
        background: var(--GrayScale-100);
      `;
  }
};

const AddButtonStyled = styled.div.withConfig({
  shouldForwardProp: prop => !['status'].includes(prop),
})`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border-radius: 10px;
  cursor: pointer;
  height: 72px;
  gap: 8px;
  flex: 1;

  ${({ status }) => getStatusStyle(status)}
`;

const AddButton = ({ title, status = '', path, onClick }) => {
  const navigate = useNavigate();

  const plusIcon = status === 'active' ? plusIcon1 : status === 'readOnly' ? plusIcon2 : plusIcon3;
  const color = status === 'disabled' ? 'GrayScale-600' : 'GrayScale-900';

  return (
    <AddButtonStyled
      status={status}
      onClick={() => {
        status != 'disabled' ? onClick() : null;
      }}>
      <Typography style={{ whiteSpace: 'pre-wrap' }} variant="body2Medium" color={color}>
        {title}
      </Typography>
      <img src={plusIcon} alt={`${title} 추가`} />
    </AddButtonStyled>
  );
};

export default AddButton;
